import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeatureSection } from './components/FeatureSection';
import { GenreSection } from './components/GenreSection';
import { CtaSection } from './components/CtaSection';
export function App() {
  return <div className="font-sans antialiased bg-white selection:bg-croon-purple selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />

        <FeatureSection bgColor="bg-croon-mint" textColor="text-black" headline="Just type anything" subtitle="Describe your song idea and watch AI bring it to life." imageUrl="https://cdn.magicpatterns.com/uploads/gAPWkNTVU1kbW76iDn1MiA/0x0ss_(27).png" imageAlt="Text to song input interface" data-id="element-4" />

        <FeatureSection bgColor="bg-croon-lightMint" textColor="text-black" headline="Write lyrics, make it yours" subtitle="Craft your own lyrics and let AI compose the perfect melody." imageUrl="https://cdn.magicpatterns.com/uploads/jL2E776dTxLaZbGB2KFKCd/0x0ss_(31).png" imageAlt="Lyrics writing interface" reverse={true} data-id="element-5" />

        <FeatureSection bgColor="bg-croon-peach" textColor="text-black" headline="Pro-quality songs in seconds" subtitle="Full-length tracks with vocals, instruments, and studio polish." imageUrl="https://cdn.magicpatterns.com/uploads/u1o9DxF3eEEDN6TFyRf253/0x0ss_(28).png" imageAlt="Music player interface showing high quality output" data-id="element-6" />

        <GenreSection data-id="element-7" />

        <FeatureSection bgColor="bg-croon-yellow" textColor="text-black" headline="Turn images into music" subtitle="Upload any photo and Croon creates a song inspired by it." imageUrl="https://cdn.magicpatterns.com/uploads/knA2rDswWUe3bhVD2XctSo/0x0ss_(30).png" imageAlt="Image to song feature" reverse={true} data-id="element-8" />

        <FeatureSection bgColor="bg-white" textColor="text-black" headline="Share anywhere and go viral" subtitle="Post your songs directly to TikTok, Instagram, and more." imageUrl="https://cdn.magicpatterns.com/uploads/oXhsqf8JYboGhV9zvCpXKn/0x0ss_(32).png" imageAlt="Share songs on social media" data-id="element-9" />
      </main>

      <CtaSection data-id="element-10" />
    </div>;
}